import React from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Row, Col, CardBody, Card, Container } from "reactstrap";
import { useSocialLogin } from "../../helpers/firebaseAuth";
import { useAuthStatus } from "../../hooks/useAuthStatus";
import RegisterForm from "./RegisterForm";

import porcherMark from "../../assets/images/porcher-logo.png";
import porcherWordmark from "../../assets/images/porcher-wordmark.png";

const Register = () => {
  document.title = "Register | Porcher";

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loginWithGoogle } = useSocialLogin();
  const { checkAuth } = useAuthStatus();

  return (
    <div className="min-vh-100 d-flex align-items-center py-5" style={{ backgroundColor: "#f8f9fa" }}>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={6} xl={5}>

            <div className="text-center mb-4">
              <Link to="/" className="d-inline-flex align-items-center gap-2">
                <img src={porcherMark} alt="" height="36" />
                <img src={porcherWordmark} alt="Porcher" height="20" />
              </Link>
              <h5 className="mt-3 mb-0 fw-semibold">Create your account</h5>
              <p className="text-muted small">Get started with Porcher in a minute</p>
            </div>

            <Card className="border-0 shadow-sm">
              <CardBody className="p-4">
                <RegisterForm
                  navigate={navigate}
                  loginWithGoogle={loginWithGoogle}
                  checkAuth={checkAuth}
                  initialMode={searchParams.get("mode")}
                />
              </CardBody>
            </Card>

            <p className="text-center text-muted small mt-4">
              © {new Date().getFullYear()} Porcher
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Register;
